export default "__VITE_ASSET__DG6rHN$b__"